import {useFormContext, useWatch} from "react-hook-form";
import {theme} from "Theme";

import {FormCheckbox, FormInputInteger} from "base/form/components";

import Stack from "@mui/system/Stack";
import Box from "@mui/material/Box";

const PermitExtensionTreesEditableCells = ({tree, extension, disabled = false}) => {
    const {control} = useFormContext();
    const extensionTypes = extension?.types || [];

    const isCuttingExtended = useWatch({
        name: `trees.${tree.id}.is_cutting_extended`,
        control,
    });

    return (
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
                my: -1, // Para que ocupe todo el espacio de la celda
                mr: -1.24,
                borderLeft: `3px solid ${theme.palette.primary.main}`,
                backgroundColor: theme.palette.pageBackground.secondary,
            }}
        >
            <Box width={40}>
                <FormCheckbox
                    name={`trees.${tree.id}.is_felling_extended`}
                    disabled={
                        disabled || !extensionTypes.includes("felling") || !tree.felling
                    }
                />
            </Box>
            <Box width={40}>
                <FormCheckbox
                    name={`trees.${tree.id}.is_cutting_extended`}
                    disabled={
                        disabled || !extensionTypes.includes("cutting") || !tree.cutting
                    }
                />
            </Box>
            <Box width={64}>
                <FormInputInteger
                    name={`trees.${tree.id}.number_of_logs_ext`}
                    style={{
                        maxWidth: 64,
                        "& input": {textAlign: "center", fontSize: "0.8rem", p: 0.5},
                    }}
                    disabled={
                        disabled ||
                        !extensionTypes.includes("cutting") ||
                        !tree.cutting ||
                        !isCuttingExtended
                    }
                />
            </Box>
        </Stack>
    );
};

export default PermitExtensionTreesEditableCells;
